export const TEST_IDS = {
  nav: {
    container: "nav-container",
    logo: "nav-logo",
    homeLink: "nav-link-home",
    servicesLink: "nav-link-services",
    quoteLink: "nav-link-quote",
    pipelineLink: "nav-link-pipeline",
    projectsLink: "nav-link-projects",
    analyticsLink: "nav-link-analytics",
    mobileMenuBtn: "nav-mobile-menu-btn",
  },
  hero: {
    section: "hero-section",
    ctaQuote: "hero-cta-quote-button",
    ctaServices: "hero-cta-services-button",
  },
  services: {
    section: "services-section",
    card: (id) => `service-pillar-card-${id}`,
  },
  calculator: {
    section: "calculator-section",
    serviceOption: (id) => `calculator-option-${id}`,
    scaleOption: (scale) => `calculator-scale-${scale}`,
    addonOption: (id) => `calculator-addon-${id}`,
    timelineOption: (id) => `calculator-timeline-${id}`,
    totalDisplay: "calculator-total-budget-display",
    submitBtn: "calculator-submit-btn",
  },
  pipeline: {
    section: "pipeline-section",
    filterService: "pipeline-filter-service",
    filterStatus: "pipeline-filter-status",
    leadCard: (id) => `lead-pipeline-card-${id}`,
    statusDropdown: (id) => `lead-status-dropdown-${id}`,
  },
  clientHub: {
    section: "client-hub-section",
    projectSelector: "project-selector",
    timelineStep: (idx) => `timeline-step-${idx}`,
  },
  analytics: {
    section: "analytics-section",
    chart: "analytics-performance-chart",
    kpiCard: (name) => `analytics-kpi-${name}`,
  },
  footer: {
    section: "footer-section",
    ctaBtn: "footer-cta-btn",
  },
  leadForm: {
    modal: "lead-form-modal",
    nameInput: "lead-form-name",
    emailInput: "lead-form-email",
    phoneInput: "lead-form-phone",
    companyInput: "lead-form-company",
    notesInput: "lead-form-notes",
    submitBtn: "lead-capture-form-submit",
  },
};
